import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { http, errorText } from "@/lib/api";

export const BuyForm = ({ slug }) => {
  const [f, setF] = useState({ email: "", name: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await http.post(`/books/${slug}/checkout`, f);
      window.location.assign(r.data.url);
    } catch (err) {
      toast.error(errorText(err));
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 w-full max-w-xl" data-testid="book-buy-form">
      <Input placeholder="Navn" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="rounded-none h-12" data-testid="book-buy-name" />
      <Input required type="email" placeholder="E-post (tilgangslenke sendes hit)" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="rounded-none h-12" data-testid="book-buy-email" />
      <button disabled={busy} className="px-8 h-12 bg-[#1A1A1A] text-[#FDFBF7] text-sm whitespace-nowrap hover:bg-[#8C6E48] transition-colors disabled:opacity-50" data-testid="book-buy-btn">{busy ? "Åpner betaling…" : "Kjøp håndboken"}</button>
    </form>
  );
};

export function BookPayment() {
  const [q] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking");
  useEffect(() => {
    let tries = 0;
    let timer;
    const check = () => http.get(`/books/orders/${q.get("ordre")}/verify`).then((r) => {
      if (r.data.status === "paid" && r.data.token) return nav(`/handbok/les/${r.data.token}`, { replace: true });
      if (r.data.status === "pending" && tries++ < 10) { timer = setTimeout(check, 3000); return; }
      setState(r.data.status);
    }).catch(() => setState("error"));
    check();
    return () => clearTimeout(timer);
  }, [q, nav]);
  const msg = {
    checking: "Vi bekrefter betalingen…",
    pending: "Betalingen er ikke bekreftet ennå. Du får tilgangslenken på e-post så snart den er godkjent.",
    failed: "Betalingen ble ikke gjennomført. Ingen beløp er trukket.",
  }[state] || "Vi kunne ikke bekrefte betalingen. Kontakt oss, så hjelper vi deg.";
  return (
    <div className="px-6 md:px-16 lg:px-24 py-24 max-w-2xl" data-testid="book-payment-page">
      <p className="eyebrow mb-4">Betaling</p>
      <p className="text-2xl font-serif-display" data-testid="book-payment-status">{msg}</p>
      {state !== "checking" && <Link to="/handbok" className="inline-block mt-8 text-sm underline" data-testid="book-payment-back">Tilbake til håndboken</Link>}
    </div>
  );
}
